"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { Button, Text } from "@nxt-costco-com/forge-components";
import { AccountAlt } from "@nxt-costco-com/forge-icons/icons/AccountAlt";
import { Analytics } from "../../../Analytics/index.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { useAuth } from "../../../../hooks/auth/useAuth/index.js";
import { buttonStyles, iconStyles, textStyles } from "./styles.js";
const Mobile = ({
  dataTestId,
  entry
}) => {
  const { signIn } = useAuth();
  const uniqueId = `${dataTestId}-signin-mobile`;
  return /* @__PURE__ */ jsx(
    CostcoBox,
    {
      "data-testid": "signin-mobile",
      sx: { display: { lg: "none", xs: "block" } },
      children: /* @__PURE__ */ jsxs(
        Button,
        {
          onClick: () => signIn(),
          sx: buttonStyles,
          uniqueId,
          variant: "text-button",
          children: [
            /* @__PURE__ */ jsx(CostcoBox, { component: AccountAlt, sx: iconStyles }),
            /* @__PURE__ */ jsx(Text, { sx: textStyles, uniqueId, children: entry.active_state.active_state_link.title })
          ]
        }
      )
    }
  );
};
const Desktop = ({
  dataTestId,
  entry
}) => {
  const { signIn } = useAuth();
  const uniqueId = `${dataTestId}-signin-desktop`;
  return /* @__PURE__ */ jsx(
    CostcoBox,
    {
      "data-testid": "signin-desktop",
      sx: { display: { lg: "block", xs: "none" } },
      children: /* @__PURE__ */ jsx(
        Button,
        {
          onClick: () => signIn(),
          uniqueId,
          variant: "text-button",
          children: /* @__PURE__ */ jsx(Text, { sx: textStyles, uniqueId, children: entry.inactive_state.inactive_state_link.title })
        }
      )
    }
  );
};
function SignInRegisterView({
  dataTestId,
  entry
}) {
  if (!entry) return null;
  return /* @__PURE__ */ jsxs(
    Analytics,
    {
      analyticData: {
        component: {
          trackedData: [
            entry.inactive_state.inactive_state_link.title
          ]
        }
      },
      children: [
        /* @__PURE__ */ jsx(Mobile, { entry, dataTestId }),
        /* @__PURE__ */ jsx(Desktop, { entry, dataTestId })
      ]
    }
  );
}
export {
  SignInRegisterView
};
